var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"icon-image",class:_vm.classWrapper},[_c('img',{attrs:{"src":_vm.src || '',"alt":"","width":_vm.width,"height":_vm.height}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }